// Adopt every handoff-owned image once the visitor is a real member.
//
// A conversion made through the landing page belongs to the landing's guest
// account, not the app session; ResultView claims one image when a member
// opens its URL, but a member who registers and goes straight to the gallery
// would never see it. This sweep claims every pending proof in one go.
// Proofs live in sessionStorage (per tab), so the sweep covers the common
// same-tab landing -> convert -> register flow.
import { apiClient } from "@shared/services/api";
import { pendingGuests } from "@shared/services/session";
import { readJson } from "../../../../../shared-client/guestSession.mjs";

export async function claimPendingGuestImages() {
  let claimed = 0;
  for (const key of pendingGuests.keys()) {
    const match = /^\/images\/(\d+)$/.exec(key || "");
    const proof = match && readJson(pendingGuests, key);
    if (!proof || !proof.access_token) continue;
    try {
      await apiClient.post(
        `/apps/upscale/images/${match[1]}/claim`,
        { guest_token: proof.access_token },
        { skipAuthRecovery: true }
      );
      pendingGuests.removeItem(key);
      claimed += 1;
    } catch (e) {
      // 409 = that image's work is still running; keep the proof so
      // ResultView (or the next sweep) can claim it later. A proof the
      // server no longer recognises is dead weight - drop it.
      const status = e.response && e.response.status;
      if (status === 401 || status === 404 || status === 410) {
        pendingGuests.removeItem(key);
      }
    }
  }
  return claimed;
}
